module.exports = __webpack_public_path__ + "static/media/404_Icon.5169d7bb.svg";